import React, { useEffect, useState } from 'react';
import { UTILS } from '../../constants';
import axios from 'axios';
import './index.css';
import { useSelector } from 'react-redux';

export const MoveDepartment = ({
  setgetId,
  cardDetail,
  handleClose,
  fetchCardsForPopUp,
}) => {
  console.log('MoveasdasdDepartment', cardDetail);
  const [departments, setDepartments] = useState([]);
  const [boardLists, setBoardLists] = useState([]);
  let [departmentId, setDepartmentId] = useState(null);
  let [boardListId, setBoardId] = useState(null);
  let [positionId, setPositionId] = useState(null);
  const numbers = Array.from({ length: 50 }, (_, i) => i + 1);

  let departmentData = useSelector((state) => state.slice);
  // console.log("globally selected---> ",departmentData);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await axios.get(
          `${UTILS.API_url}board/v1/departments`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
              // Optionally include other headers if needed
            },
          }
        );
        const data = response.data; // Adjust based on your API response structure

        setPositionId(1);
        setDepartmentId(localStorage.getItem('departmentIdds'));
        setDepartments(data?.departments);
        // (value) => value.id == localStorage.getItem('departmentIdds')
        console.log('filterDepartment', cardDetail?.department_id);
        setDepartmentId(cardDetail?.department_id);
        let filterDepartment = data?.departments.filter((value) => {
          if (cardDetail?.department_id) {
            return value.id == cardDetail?.department_id;
          } else {
            return value.id == localStorage.getItem('departmentIdds');
          }
        });
        setBoardLists(filterDepartment);
        filterDepartment.length > 0 &&
          filterDepartment[0]?.board_lists.map((boardList) =>
            cardDetail?.board_list?.title &&
            boardList.title === cardDetail?.board_list?.title
              ? setBoardId(boardList.id)
              : ''
          );
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };
    fetchDepartment();
  }, []);

  const handleDepartmentChange = (event) => {
    // console.log("id", event.target.value);
    let filterDepartment = departments.filter(
      (value) => value.id == event.target.value
    );
    // console.log("filterDepartment", filterDepartment);
    setDepartmentId(event.target.value);
    setBoardLists(filterDepartment);
  };
  const handleBoardlistChange = (event) => {
    setBoardId(event.target.value);
    setPositionId(1);
  };

  const onMoveDepartment = async () => {
    // console.log("departmentId",departmentId,boardListId, positionId);
    console.log('boardListId', boardListId);
    // console.log("positionId",positionId);
    console.log('cardDetail?.id', cardDetail?.id);

    const data = new FormData();
    data.append('department_id', departmentId);
    data.append('task_id', cardDetail?.id);
    data.append('position', positionId);
    data.append('board_list_id', boardListId);

    const mainurl = `${UTILS.API_url}board/v1/board-list-cards/move-card`;
    console.log('move dept url ---> ', mainurl);
    console.log('move dept data ---> ', data);

    console.log('department_id', departmentId);
    console.log('task_id', cardDetail?.id);
    console.log('position', positionId);
    console.log('board_list_id', boardListId);

    let bakedData = {
      department_id: parseInt(departmentId),
      task_id: parseInt(cardDetail?.id),
      position: parseInt(positionId),
      board_list_id: parseInt(boardListId),
    };
    console.log('---> ', bakedData);
    try {
      const response = await axios.post(mainurl, bakedData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          'Content-Type': 'application/json',
        },
      });

      // console.log('Response:', response.data);
      if (response.data.success) {
        fetchCardsForPopUp(departmentId);
        setgetId(null);
        handleClose();
        setBoardId(null);
        setDepartmentId(null);
        setPositionId(null);
      }
    } catch (error) {
      console.log('catch---> ', bakedData);
      console.error('Error:', error);
    }
  };
  return (
    <div className="add-member">
      <button className="close-btn-pop close-member">
        <span
          className="material-symbols-outlined"
          onClick={() => setgetId(null)}
        >
          close
        </span>
      </button>
      <div className="dropdown-fields">
        <h4 className="mem-heading">Move Department</h4>
      </div>
      <div>
        {/* <p>Select destination</p> */}
        <div>
          <div style={{ fontWeight: 'bolder' }}>Board</div>
          <select onChange={handleDepartmentChange} className="selectBox">
            <option value="" disabled>
              Department
            </option>
            {/* ((cardDetail?data?.department)?(department.id == cardDetail?data?.department) :(department.id == localStorage.getItem('departmentIdds')))? */}
            {departments &&
              departments.map((department) =>
                (cardDetail?.department_id &&
                  department.id === cardDetail?.department_id) ||
                department.id === localStorage.getItem('departmentIdds') ? (
                  <option key={department.id} value={department.id} selected>
                    {department.name}
                  </option>
                ) : (
                  <option key={department.id} value={department.id}>
                    {department.name}
                  </option>
                )
              )}
          </select>
        </div>
      </div>
      <div>
        <div className="section_position">
          <div style={{ width: '100%' }}>
            <div style={{ fontWeight: 'bolder' }}>Board List</div>
            <select onChange={handleBoardlistChange} className="selectBox">
              <option value="" disabled>
                Board list
              </option>
              {boardLists.length > 0 &&
                boardLists[0]?.board_lists.map((boardList) =>
                  cardDetail?.board_list?.title &&
                  boardList.title === cardDetail?.board_list?.title ? (
                    <option key={boardList.id} value={boardList.id} selected>
                      {boardList.title}
                    </option>
                  ) : (
                    <option key={boardList.id} value={boardList.id}>
                      {boardList.title}
                    </option>
                  )
                )}
            </select>
          </div>
          <div style={{ width: '100%' }}>
            <div style={{ fontWeight: 'bolder' }}>Position</div>
            <select
              onChange={(e) => setPositionId(e.target.value)}
              className="selectBox"
            >
              <option value="" style={{ fontSize: '14px' }} disabled>
                Position
              </option>
              {numbers.map((number) =>
                //  (number  == 1)?
                (
                  cardDetail?.position
                    ? number === cardDetail?.position
                    : number == 1
                ) ? (
                  <option key={number} value={number} selected>
                    {number}
                  </option>
                ) : (
                  <option key={number} value={number}>
                    {number}
                  </option>
                )
              )}
            </select>
          </div>
        </div>
        <button
          onClick={onMoveDepartment}
          className="btn btn-light att-add activity-detail"
        >
          Move
        </button>
      </div>
    </div>
  );
};
